import React from 'react';
import PropTypes from 'prop-types';

class TableNav extends React.Component {
  disableButton(link) {
    return !link;
  }

  render() {
    if (!this.props.nextLink && !this.props.prevLink) { return false; }
    return (
      <nav className="table-nav">
        <button
          className="btn btn-small btn-secondary"
          title={I18n.t('js.previous')}
          onClick={this.props.onPrevClick}
          disabled={this.disableButton(this.props.prevLink)}
        >
          <i className="fa fa-chevron-left" />
        </button>

        <button
          className="btn btn-small btn-secondary"
          title={I18n.t('js.next')}
          onClick={this.props.onNextClick}
          disabled={this.disableButton(this.props.nextLink)}
        >
          <i className="fa fa-chevron-right" />
        </button>
      </nav>
    );
  }
}

TableNav.propTypes = {
  nextLink: PropTypes.object,
  prevLink: PropTypes.object,
  onPrevClick: PropTypes.func,
  onNextClick: PropTypes.func,
};

export default TableNav;
